import {
  Box,
  Button,
  Chip,
  Container,
  Grid,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import React, { useContext } from "react";
import ConfigurationContext from "../../../context/Configuration";
import DietaryBadges from "./DietaryBadges";
import useStyles from "./styles";

function ItemCard(props) {
  const theme = useTheme();
  const { title, foods } = props;
  const classes = useStyles();
  const configuration = useContext(ConfigurationContext);
  return (
    <Container className={classes.cardContainer}>
      <Typography
        variant="h5"
        color="textSecondary"
        className={`${classes.titleText} ${classes.boldText}`}
      >
        {title}
      </Typography>
      <Grid container spacing={2}>
        {foods.map((item, index) => (
          <Grid
            key={index}
            item
            xs={12}
            md={6}
            style={{ paddingBottom: "20px" }}
          >
            <Paper
              elevation={1}
              square
              className={classes.itemContainer}
              onClick={() => props.onPress({ ...item, ...props.restaurant })}
            >
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
              >
                <Box>
                  <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      className={classes.boldText}
                    >
                      {item.title}
                    </Typography>
                    <DietaryBadges tags={item.dietaryTags} />
                    {/* DoorDash-style "#N Most liked" badge (top 3 only). */}
                    {item.mostLikedRank && item.mostLikedRank <= 3 && (
                      <Chip
                        label={`#${item.mostLikedRank} Most liked`}
                        size="small"
                        sx={{
                          ml: 0.75, height: 20, fontSize: "0.68rem", fontWeight: 700,
                          bgcolor: "#FEF2F2", color: "#CC0000", border: "1px solid #FECACA",
                          "& .MuiChip-label": { px: 0.75 },
                        }}
                      />
                    )}
                  </Box>
                  {/* "% liked (N)" — shown once the dish has any votes. */}
                  {item.likedPercent != null && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.25 }}>
                      <ThumbUpAltIcon sx={{ fontSize: 13, color: "#16A34A" }} />
                      <Typography variant="caption" sx={{ color: "#374151", fontWeight: 600, fontSize: "0.72rem" }}>
                        {item.likedPercent}%
                      </Typography>
                      <Typography variant="caption" sx={{ color: "#9CA3AF", fontSize: "0.72rem" }}>
                        ({item.voteCount})
                      </Typography>
                    </Box>
                  )}
                  <Typography variant="caption" className={classes.itemDesc}>
                    {item.description}
                  </Typography>
                </Box>
                <Typography variant="body2" color="textSecondary">
                  {/* Card shows the no-addon price. The backend already returns
                      each price marked up AND rounded per the menu's rule, so we
                      display it as-is (no client-side rounding). */}
                  {`${configuration.currencySymbol} ${parseFloat(item.variations[0].price).toFixed(2)}`}
                  {item.variations[0].discounted > 0 && (
                    <Typography
                      variant="caption"
                      className={classes.discountText}
                    >
                      {`${configuration.currencySymbol} ${parseFloat(
                        item.variations[0].price + item.variations[0].discounted
                      ).toFixed(2)}`}
                    </Typography>
                  )}
                </Typography>
              </Box>
              <Box
                className={classes.imageContainer}
                style={{
                  backgroundImage: `url(${item.image})`,
                  borderRadius: 10,
                }}
              >
                <Button className={classes.addContainer}>
                  <AddIcon style={{ color: theme.palette.common.white }} />
                </Button>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default React.memo(ItemCard);
